import { useEffect } from "react";
import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";
import { EventPayloadMapper } from "@/hooks/useTrack/useTrack.decl";
import { useBaseStore } from "@/store/store";
import { useTrackHelpers } from "../useTrackHelpers/useTrackHelpers";

const CC_REGEX = /\/conversations/;
const CC_PREVIEW_REGEX = /\/conversations\?.*preview_call.*/;
const CALL_HISTORY_REGEX = /assets\.aircall/;
const CC_TRACKERS = /ai-assist\/trackers/;
const CALL_SCORING = /ai-assist\/scorecards/;

function pickSource(): EventPayloadMapper["assets_page_open"]["from_source"] {
  switch (true) {
    case CC_TRACKERS.test(document.referrer):
      return "conversation_center_trackers";
    case CALL_SCORING.test(document.referrer):
      return "call_scoring";
    case CC_PREVIEW_REGEX.test(document.referrer):
      return "conversation_center_preview";
    case CALL_HISTORY_REGEX.test(document.referrer):
      return "call_history";
    case CC_REGEX.test(document.referrer):
      return "conversation_center";
    default:
      return "other";
  }
}

export function useTrackAssetsPageOpen() {
  const { track } = useTrack();

  const { call } = useCall();
  const transcriptionSettings = useBaseStore(
    (store) => store.transcriptionSettings
  );
  const {
    transcription_displayed,
    summary_displayed,
    key_topics_displayed,
    sentiment_displayed,
    talk_ratio_displayed,
    reason_for_no_transcript_displayed,
    sentiment,
    action_items_displayed,
  } = useTrackHelpers();

  useEffect(() => {
    track("assets_page_open", {
      call_id: call?.id,
      call_uuid: call?.uuid,
      call_score_displayed: false,
      conversation_player_view: "simple",
      transcription_language: transcriptionSettings?.lineLanguage,
      from_source: pickSource(),
      key_topics_displayed,
      action_items_displayed,
      reason_for_no_transcript_displayed,
      sentiment_displayed,
      sentiment,
      summary_displayed,
      talk_ratio_displayed,
      transcription_displayed,
    });
  }, []);
}
